import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as AddIcon } from 'assets/icons/addIcon.svg';
import { CreateButton } from 'features/kpi/containers/KpiPreview/styled';
import { theme } from 'styles';

import { ActionsW } from './styled';

interface AddAndExtendActionsProps {
  addIconLink?: string;
  addLinkState?: unknown;
  equipments?: boolean;
  onAdd?: () => void;
}

export function AddAndExtendActions({
  addIconLink,
  addLinkState,
  equipments,
  onAdd,
}: AddAndExtendActionsProps): ReactElement {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ActionsW>
      {(addIconLink || onAdd) && (
        <CreateButton
          startIcon={<AddIcon style={{ fill: theme.palette.common.white }} />}
          onClick={() => {
            if (onAdd) {
              onAdd();
            } else if (addIconLink) {
              navigate(addIconLink, { state: addLinkState });
            }
          }}
          style={{
            height: '56px',
            padding: '16px',
            fontWeight: 400,
            fontSize: '14px',
            backgroundColor: theme.palette.info.main,
            color: theme.palette.common.white,
            borderRadius: '8px',
            textTransform: 'none',
          }}
        >
          {equipments ? t('equipments.addEquipments') : t('career.achievements.addNewGoal')}
        </CreateButton>
      )}
    </ActionsW>
  );
}
